/* eslint-disable @typescript-eslint/naming-convention */
import type { bodyTypeMessagesScope } from '../../Services/Vehicle/Vehicle.messages';
import { type MessageOptions, transformOptionsByMessageIds } from './TransformOptionsByMessageId';

export type BodyTypeMessageId = keyof typeof bodyTypeMessagesScope;

const BODY_TYPES_BY_MESSAGE_ID: Record<BodyTypeMessageId, MessageOptions> = {
  hatchback: {
    ids: ['hatchback'],
    label: 'Hatchback',
  },
  convertible: {
    ids: ['convertible'],
    label: 'Convertible',
  },
  coupe: {
    ids: ['coupe'],
    label: 'Coupe',
  },
  estate: {
    ids: ['estate'],
    label: 'Estate',
  },
  saloon: {
    ids: ['saloon'],
    label: 'Saloon',
  },
  suv: {
    ids: ['suv'],
    label: 'SUV',
  },
  pickup: {
    ids: ['pickup'],
    label: 'Pick-up',
  },
  mpv: {
    ids: ['mpv'],
    label: 'MPV',
  },
  van: {
    ids: ['van'],
    label: 'Van',
  },
};

export const BODY_TYPES = transformOptionsByMessageIds(BODY_TYPES_BY_MESSAGE_ID);
